
import React ,{useRef, useEffect,useState}from 'react'
import { Card ,Col, Row,Image,Typography,Divider} from 'antd'
import './index.css'
import axios from 'axios';
import {

  ProjectOutlined,
  FundViewOutlined,
  HomeOutlined,
  PhoneOutlined,
  PrinterOutlined,
  MailOutlined 
} from '@ant-design/icons';
const { Title } = Typography;
export default function Home() {
  const [datas, setdatas] = useState([]);
  useEffect(() => {
    axios.get('https://tang.agaii.org/Webtext.php')
      .then((response) => {
        console.log('Response Data:', response.data);
        setdatas(response.data[0]); // 假设是数组
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  }, []);
  
  return (
    <Card type="ncenter" >
      <Row>
      <Col align='justify' span={24} offset={0}><Card  style={{ marginTop: 16}}
        type="inner" >
          <Row>
          <Col span={10} offset={0}>
          <Title></Title>
        </Col>
        </Row>
        <Row>
        <Col span={6} offset={0}><Image
          width={200}
          src={require('../../img/photo.jpg')}
        /></Col>
        <Col span={10} offset={0}>
        <Title>Dr. Ying (Gina) Tang</Title>
        <Title level={4}> Professor & Associate Chair</Title>
        <Title level={5}> <a href='https://engineering.rowan.edu/'>Department of Electrical & Computer Engineering</a></Title>
        <Title level={5}> <PhoneOutlined /> Phone: <a href='tel:+18562565339'>(856) 256-5339 </a>/ <PrinterOutlined /> Fax: <a href='tel:+18562565241'>(856)-256-5241</a></Title>
        <Title level={5}> <MailOutlined /> E-mail: <a href='mailto:tang@rowan.edu'>tang@rowan.edu</a></Title>

        
        </Col>
        </Row>
        <p/>
        <Divider />
        <h4>
        {datas.Hometext1}
        </h4>
        <p/>
        <h4>
        {datas.Hometext2}       
        </h4> 
        <p/>
        <h4>
        {datas.Hometext3}       
        </h4> 
        <p/>
        <h4>
        {datas.Hometext4}       
        </h4> 
        
  
        </Card></Col>
      </Row>
  </Card>

  )
    
  
}
